import { SET_SHOW_MOBILE_SUMMARY, SET_SIDE_MENU_OPEN } from "../actions/menuActions";
import MenuState from "../stateTypes/menuState";

const initialState: MenuState = {
    sideMenuOpen: false,
    showMobileSummary: false,
};

const menuReducer = (state: MenuState = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_SIDE_MENU_OPEN:
            return {
                ...state,
                sideMenuOpen: action.sideMenuOpen,
            };
        case SET_SHOW_MOBILE_SUMMARY:
            return {
                ...state,
                showMobileSummary: action.showMobileSummary,
            };
        default:
            return state;
    }
};

export default menuReducer;
